import { nodeListToArray } from './nodeListToArray';

export function enableTabbableChildren(parent) {
    let tabbableChildren = nodeListToArray(parent.querySelectorAll('a, button, input, select, textarea'));
    tabbableChildren.forEach(child => {
        child.tabIndex = null;
    });
}
